/** Console error wrapper */
const error = (...args: any[]) => {
  console.error("[Chat SDK]:", ...args);
};

export default error;
